import React from 'react'
import { Carousel } from 'antd';
import { Typography, Skeleton } from 'antd';

import mainImg1 from '../../assets/main/image1.jpg';
import mainImg2 from '../../assets/main/image2.jpg';
import mainImg3 from '../../assets/main/image3.png';
import mainImg4 from '../../assets/main/image4.png';
import mainImg5 from '../../assets/main/image5.png';

const { Title } = Typography;

const titleStyle = {
    color: "white",
    margin:"80px"
}

const contentStyle = {
    height: 'calc(100vh - 60px)',
    color: '#fff',
    lineHeight: '500px',
    textAlign: 'center',
    background: 'black',
    // background: 'rgb(93, 153, 148)',
  };

function LandingPage() {
  return (
    <div>
        <Carousel autoplay >
            <div>
            <h3 style={contentStyle}><img src={mainImg1} style={{height: "100%", width:"100%", objectFit: "cover"}}/></h3>
            </div>
            <div>
            <h3 style={contentStyle}><img src={mainImg2} style={{height:"100%", width:"100%",objectFit: "cover"}}/></h3>
            </div>
            <div>
            <h3 style={contentStyle}><img src={mainImg3} style={{height:"100%", width:"100%",objectFit: "cover"}}/></h3>
            </div>
            <div>
            <h3 style={contentStyle}><img src={mainImg4} style={{height:"100%", width:"100%",objectFit: "cover"}}/></h3>
            </div>
            <div>
            <h3 style={contentStyle}><img src={mainImg5} style={{height:"100%", width:"100%",objectFit: "cover"}}/></h3>
            </div>
        </Carousel>
        <Title level={1} style={titleStyle}>Home</Title>
        <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width:"50%", margin:"auto", marginBottom:"100px"}}>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
        </div>
  </div>
  )
}

export default LandingPage